import { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { logEvent } from '@/utils/logger';

interface UseReCaptchaOptions {
  onError?: (error: Error) => void;
  onReset?: () => void;
  logErrors?: boolean;
}

export const useReCaptcha = (options: UseReCaptchaOptions = {}) => {
  const { onReset, logErrors = true } = options;
  const recaptchaRef = useRef<ReCAPTCHA>(null);

  const executeReCaptcha = async () => {
    try {
      const token = await recaptchaRef.current?.executeAsync();
      return token as string;
    } catch (error) {
      if (logErrors) {
        logEvent.error('ReCAPTCHA Error', { error });
      }
      throw error;
    }
  };

  const resetReCaptcha = () => {
    recaptchaRef.current?.reset();
    onReset?.();
  };

  const onReCaptchaChange = (captchaCode: string | null) => {
    if (!captchaCode) return;
    resetReCaptcha();
  };

  return {
    recaptchaRef,
    executeReCaptcha,
    resetReCaptcha,
    onReCaptchaChange,
  };
};
